import axios from 'axios';

const dismiss = async (id: string) => axios.post(`/listing/duplicates/${id}`);

export default dismiss;
